/*
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2019-08-21 08:58:45
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-05-11 19:27:45
 */
/*
 * mutations
 * */
import storage from './storage';

const mutations = {
  // 更新menuList
  upMenulist(state, data) {
    console.log('data', data)
    state.menuListAll = data;
  },
  // 更新常用menuList
  upActiveMenulist(state, data) {
    state.activeMenuList = data;
    storage.setLocalItem('activeMenuList', data);  // 加入缓存
  },
  // 更新登录状态
  setLoginStatus(state, data) {
    state.isLogin = data;
    storage.setSessionItem('isLogin', data);  // 加入缓存
  },
  // 新增tab
  addTab(state, data) {
    state.tabsList.push(data)
  },
  // 删除tab
  deleteTab(state, data) {
    state.tabsList.splice(data.index, 1)
  },
  updatedBreadName(state, data) {
    state.breadNameList = []
    state.breadNameList = data
  },
  updatedTheme(state, data) {
    state.defaultTheme = data
    storage.setLocalItem('defaultTheme', data);  // 加入缓存
  },
  updatedActiveMenu(state, data) {
    state.activeMenu = data
    storage.setSessionItem('activeMenu', data);  // 加入缓存
  },
  // 地址列表
  upAddressList(state, data) {
    state.addressList = data
    storage.setLocalItem('addressList', data);  // 加入缓存
  },
  // 添加contentSrc
  addContentSrc(state, data) {
    state.contentSrc = data
    storage.setSessionItem('contentSrc', data);  // 加入缓存
  },
  // 数据词典
  setOrgTypeList(state, data) {
    state.orgTypeList = data
    storage.setLocalItem('orgTypeList', data);  // 组织类型查询 【10-小区,11-社区,12-街道】
  },
  setOrgSubTypeList(state, data) {
    state.orgSubTypeList = data
    storage.setLocalItem('orgSubTypeList', data);  // 组织子类型查询 【D-部门,F-楼层楼宇结构,N-默认】
  },
  setPositionType(state, data) {
    state.positionType = data
    storage.setLocalItem('positionType', data);  //轮播图位置获取 【01-首页顶部,02-首页中部,03-我的顶部】
  },
  setVisitedScopeType(state, data) {
    state.visitedScopeType = data
    storage.setLocalItem('visitedScopeType', data);  // 可见范围获取【01-所有人员,02-小区人员,03-小区业主】
  },
  setVisitedScopeTypeTwo(state, data) {
    state.visitedScopeTypeTwo = data
    storage.setLocalItem('visitedScopeTypeTwo', data);  // 可见范围获取-swiper 【01-所有人员,02-小区人员,03-小区业主】
  },
  setPublishStatus(state, data) {
    state.publishStatus = data
    storage.setLocalItem('publishStatus', data);  // 上架状态获取 【01-上架,02-下架】
  },
  setAdvertiseType(state, data) {
    state.advertiseType = data
    storage.setLocalItem('advertiseType', data);  // 公告类型获取
  },
  setModuleJsonType(state, data) {
    state.moduleJsonType = data
    storage.setLocalItem('moduleJsonType', data);  // 权限--模块类型获取 【module-模块,menu-菜单,page-页面,operation-操作】
  },
  setModuleSubJsonType(state, data) {
    state.moduleSubJsonType = data
    storage.setLocalItem('moduleSubJsonType', data);  // 权限--模块类型获取 【add-新增,del-删除,mod-修改,list-列表,detail-详情,imp-导入,exp-导出,status-状态】
  },
  setUserIdJsonType(state, data) {
    state.userIdJsonType = data
    storage.setLocalItem('userIdJsonType', data);  // 权限--证件类型获取 【1-身份证】
  },
  setUserSexyJsonType(state, data) {
    state.userSexyJsonType = data
    storage.setLocalItem('userSexyJsonType', data);  // 权限--性别获取 【1-男,2-女,N-保密】
  },
  setModuleTypeList(state, data) {
    state.moduleTypeList = data
    storage.setLocalItem('moduleTypeList', data);  // 模块分类  【00-应用,01-菜单】
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js